import Litepicker from 'litepicker';

export default bookGreenFee => {

    // console.log('bookGreenFee');
    const bookGreenFeeHeight = bookGreenFee.offsetHeight;

    const headerHeight = document.querySelector('header').offsetHeight;
    const navHeight = document.querySelector('.section.hero-top').offsetHeight;
    const heroHeight = document.querySelector('.section.hero').offsetHeight;
    const topbarHeight = document.querySelector('.topbar').offsetHeight;
    const bookGreenFeeForm = bookGreenFee.querySelector('form');
    const selectCourse = bookGreenFee.querySelector('#select-course');
    const inputDate = bookGreenFee.querySelector('#input-date');
    const btnBook = bookGreenFee.querySelector('#book-green-fee-btn');

    if(inputDate){
      const datePicker = new Litepicker({
          element: inputDate,
          firstDay: 1,
          format: 'DD/MM/YYYY',
          // bookedDaysFormat: 'YYYY/MM/DD',
          lang: 'fr-FR',
          numberOfMonths: 2,
          numberOfColumns: 2,
          // singleMode: false,
          autoApply: true,
          // autoApply: false,
          parentEl: inputDate.parentNode,
          onShow: function(){
              // Calculate if Calendar needs to be shown above the Date field
              let picker = document.querySelector('.litepicker');
              let bounds = picker.getBoundingClientRect();
              let vh = window.innerHeight;

              if( vh < bounds.bottom ){
                  document.querySelector('.litepicker').classList.add('above');
              }
          },
          onHide: function(){
              // Remove 'Above' class
              document.querySelector('.litepicker').classList.remove('above');
          }
      });
    }

    if(typeof datePicker !== 'undefined'){
      btnBook.addEventListener('click', event => {
          event.preventDefault();

          const selectedDate = new Date(datePicker.getDate());
          const dataUrl = bookGreenFeeForm.getAttribute('data-url');
          const bookedCourse = selectCourse.value;
          const bookedDate = `${selectedDate.getFullYear()}/${selectedDate.getMonth() + 1}/${selectedDate.getDate()}`;

          if (selectCourse.value !== '') {
              selectCourse.parentNode.classList.remove('error');
          } else {
              selectCourse.parentNode.classList.add('error');
          }

          if (inputDate.value !== '') {
              inputDate.parentNode.classList.remove('error');
          } else {
              inputDate.parentNode.classList.add('error');
          }

          if (selectCourse.value !== '' && inputDate.value !== '') {
                window.open( `${dataUrl}?origin=OGC_WEBSITE&parcoursId=${bookedCourse}&date=${bookedDate}`, '_blank');
              //window.location = `${dataUrl}?origin=OGC_WEBSITE&parcoursId=${bookedCourse}&date=${bookedDate}`;
          }
      });
    }
    
    resizeBook();
    window.onresize = resizeBook;
    window.onscroll = resizeBook;

    function resizeBook(){
     /*   const mainContentTop = document.querySelector('.main-content').getBoundingClientRect().top;

        let ww = window.innerWidth;
        let topBlocPosition = window.innerHeight - mainContentTop - bookGreenFeeHeight - 30;

        if (topBlocPosition >= window.innerHeight - bookGreenFeeHeight - 30 - 66) {
          topBlocPosition = window.innerHeight - bookGreenFeeHeight - 30 - 66;
        }

        if( ww >= 992 ){
            bookGreenFee.style.bottom = `${topBlocPosition}px`;
        } else {
           bookGreenFee.style.bottom = `69px`;
        }*/
    }
};
